import { moduleNameMap } from '@/shared/utils/module_helpers';

const forma = {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};

const materiaPrimaFamilia = {
  Codigo: null,
  Descripcion: '',
  CodigoAdicional: null,
  Activo: true,
};

const suaje = {
  Activo: true,
  AnchoOptimoMaterial: null,
  Codigo: null,
  CodigoClaseSuaje: null,
  CodigoForma: null,
  CodigoMaterial: null,
  CodigoSuaje: null,
  CodigoSuajeTipo: null,
  CodigoUsuarioActualizacion: null,
  CodigoUsuarioCreacion: null,
  CotizacionElemento: [],
  Desarrollo: null,
  Engranaje: null,
  EtiquetasDesarrollo: null,
  EtiquetasEje: null,
  FechaActualizacion: null,
  FechaCreacion: null,
  Forma: {
    Codigo: null,
    Descripcion: null,
    Activo: true,
  },
  GapDesarrolloIn: null,
  GapDesarrolloMm: null,
  GapEjeIn: null,
  GapEjeMm: null,
  MedidaDesarrolloIn: null,
  MedidaDesarrolloMm: null,
  MedidaEjeIn: null,
  MedidaEjeMm: null,
  SolicitudElemento: [],
  TienePleca: false,
  EsAutomatica: false,
  EsCorteCompleto: false,
  MinEtiquetaImpresa: null,
  MinEtiquetaSinImpresion: null,
  Material: {
    Activo: true,
    Codigo: null,
    CodigoAdicional: null,
    CodigoFamilia: null,
    CodigoMaterialTipo: null,
    CodigoMoneda: null,
    CodigoUnidadMedida: null,
    CodigoUsuarioActualizacion: null,
    CodigoUsuarioCreacion: null,
    Costo: null,
    Descripcion: null,
    FechaActualizacion: null,
    FechaCreacion: null,
  },
  SuajeMateriaPrimaFamilia: [],
};

const elementoTipo = {
  Codigo: null,
  Descripcion: null,
  Activo: false,
  CodigoElementoBase: null,
  Tintas: false,
  ElementoBase: {
    Codigo: null,
    Descripcion: null,
    Activo: false,
    Utilidad: null,
  },
};

const centroMaterial = {
  Codigo: null,
  Descripcion: '',
  Activo: true,
};

const ElementoModelo = {
  AltoTotal: 0,
  AnchoMaterial: 0,
  AnchoTotal: 0,
  Base: 0,
  CantidadCambios: 0,
  CantidadColoresAdhesivo: 0,
  CantidadColoresFrente: 0,
  CantidadColoresLiner: 0,
  CantidadPolimeros: null,
  CentroMaterial: centroMaterial,
  Codigo: null,
  CodigoCentro: null,
  CodigoElementoTipo: 2,
  CodigoMateriaPrimaFamilia: null,
  CodigoForma: 1,
  CodigoSolicitud: null,
  CodigoSuaje: null,
  Desarrollo: 0,
  ElementoTipo: elementoTipo,
  Engranaje: 0,
  EtiquetasDesarrollo: 0,
  EtiquetasEje: 0,
  Forma: forma,
  GapDesarrollo: 0,
  GapEje: 0,
  ItemElemento: 0,
  MateriaPrimaFamilia: materiaPrimaFamilia,
  MedidaDesarrollo: 0,
  MedidaEje: 0,
  PaquetesPorCaja: null,
  PiezasPorPresentacion: null,
  EtiquetasPaso: null,
  Presentacion: null,
  Sellado: 0,
  Solapa: 0,
  Suaje: suaje,
  TroquelNuevo: null,
  UnidadMedida: 'mm',
};

const ElementoProcesoModelo = {
  Codigo: null,
  CodigoSolicitud: null,
  CodigoSeccion: 0, //Reemplazar
  CodigoSolicitudElemento: null,
  CodigoProceso: 0, //Reemplazar
  ItemProceso: 0, //Reemplazar
  CodigoRecurso: 0,
  Orden: 0,
  CodigoMateriaPrimaFamilia: null,
  Porcentaje: null,
  Observaciones: null,
  Proceso: {}, // Reemplazar
  Recurso: {
    Codigo: null,
    Descripcion: null,
    CodigoRecursoTipo: null,
    CodigoRenglonEquivalente: null,
    CostoHora: null,
    CodigoMoneda: null,
    MetrosPreparacion: null,
    MetrosColor: null,
    PorcentajeMerma: null,
    TiempoPreparacionFijo: null,
    TiempoPreparacionColor: null,
    PromedioProduccion: null,
    PromedioProduccionTroquelado: null,
    Activo: true,
    CodigoTipoCilindro: null,
    AnchoMinimo: null,
    AnchoMaximo: null,
    Colores: null,
    CantidadEstacionesSuaje: null,
    CantidadCuerposUv: null,
    SuajeMagnetico: null,
    Laminacion: null,
    ColdFoil: null,
    BackPrint: null,
    Reverso: null,
    EmbobinadoresEnLinea: null,
    InkjetEnLinea: null,
    Silicon: null,
    Stacker: null,
    RecursoTipo: {
      Codigo: null,
      Descripcion: null,
      CodigoEquivalente: null,
      Activo: true,
    },
    Moneda: {
      Codigo: 2,
      Descripcion: 'Dolar americano',
      Abreviatura: 'U$S',
      Activo: true,
    },
  },
  MateriaPrimaFamilia: {
    Codigo: null,
    Descripcion: '',
    CodigoAdicional: null,
    Activo: true,
  },
  Forma: {
    Codigo: null,
    Descripcion: null,
    Activo: true,
  },
  Velocidad: null,
  Cantidad: null,
  Costo: null,
  Adicional: false,
  PorcentajeMerma: 0,
  CodigoSentidoBobinado: null,
  Material: {},
  // SolicitudElementoProcesoMateriales: [],
  BocasAlto: null,
  BocasAncho: null,
  DimensionAlto: null,
  DimensionAncho: null,
  CantidadColoresFrente: null,
  CantidadColoresLiner: null,
  CantidadColoresAdhesivo: null,
  CantidadCambios: null,
  Colores: null,
};

const ElementoProcesoMaterialesModelo = {
  Codigo: null,
  CodigoMaterial: null,
  Porcentaje: null,
  Espesor: null,
  Gramaje: null,
  BocasAncho: null,
  BocasLargo: null,
  BocasAlto: null,
  Ancho: null,
  Largo: null,
  Material: {},
  Alto: null,
  Densidad: null,
  Diametro: null,
  Rendimiento: null,
  MaterialTipoConfig: {},
};

export const generarElemento = (modulo, defaultData, index = 1) => {
  const elemento = {
    ...ElementoModelo,
  };

  const prefix = moduleNameMap[modulo];

  // elemento[`${prefix}ElementoTinta`] = []

  const elementoDefault = defaultData.ElementoTipo;
  const procesos = elementoDefault.ProcesoElementoTipo || [];
  delete elementoDefault['ProcesoElementoTipo'];

  elemento.ItemElemento = index;
  elemento.ElementoTipo = elementoDefault;

  elemento[`${prefix}ElementoProceso`] = procesos.map((procesoDefault) => {
    return {
      ...ElementoProcesoModelo,
      ItemProceso: index,
      CodigoProceso: procesoDefault.CodigoProceso || 0,
      Proceso: procesoDefault.Proceso || {},
      CodigoSeccion: procesoDefault.Seccion ? procesoDefault.Seccion.Codigo : 0,
      Orden: procesoDefault.Orden || 0,
      [`${prefix}ElementoProcesoMateriales`]: procesoDefault.Materiales.map((materialDefault) => {
        return {
          ...ElementoProcesoMaterialesModelo,
          CodigoMaterial: materialDefault.CodigoMaterial || null,
          Material: materialDefault.Material || {},
        };
      }),
    };
  });

  return elemento;
};
